import { Reply } from "@mui/icons-material";
import { Box, Button, Typography, IconButton, OutlinedInput, Tabs, Tab } from "@mui/material";
import TabsAndFileRenderer from "./TabsAndFileRenderer";
import React, { useState } from "react";

interface Props {
    setActiveTab: React.Dispatch<React.SetStateAction<string>>;
}

const FilesContent = ({ setActiveTab }: Props) => {
    const [value, setValue] = useState<string>("all");
    const [searchInput, setSearchInput] = useState<string>("");

    return (
        <Box sx={{ p: "2vh 0", width: "100%", height: "100%" }}>
            <Box
                sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    p: "0 2vw",
                }}
            >
                <Typography variant="h5">Source Documents</Typography>
                <Box sx={{ display: "flex", gap: 3 }}>
                    <OutlinedInput
                        sx={{
                            pr: "1.8px",
                            "& .MuiOutlinedInput-notchedOutline": {
                                borderRadius: "7.6px",
                                borderColor: "#CFCFCF",
                                overflow: "hidden",
                            },
                            "& .MuiOutlinedInput-input": {
                                height: "0.5rem",
                                padding: "14px 12px",
                            },
                        }}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            setSearchInput(e.target.value);
                        }}
                        placeholder="Search"
                        endAdornment={
                            <IconButton sx={{ borderRadius: "4px" }}>
                                <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M8.91732 15.4245C10.3225 15.4242 11.6872 14.9538 12.7941 14.0881L16.2743 17.5683L17.3937 16.4489L13.9135 12.9687C14.7796 11.8617 15.2503 10.4967 15.2507 9.09115C15.2507 5.5991 12.4094 2.75781 8.91732 2.75781C5.42528 2.75781 2.58398 5.5991 2.58398 9.09115C2.58398 12.5832 5.42528 15.4245 8.91732 15.4245ZM8.91732 4.34115C11.5369 4.34115 13.6673 6.47152 13.6673 9.09115C13.6673 11.7108 11.5369 13.8411 8.91732 13.8411C6.29769 13.8411 4.16732 11.7108 4.16732 9.09115C4.16732 6.47152 6.29769 4.34115 8.91732 4.34115Z"
                                        fill="#484848"
                                    />
                                </svg>
                            </IconButton>
                        }
                    />
                    <Button
                        sx={{
                            textTransform: "none",
                            background: "#007BFF",
                            color: "#fff",
                            px: 2,
                            borderRadius: "7.31px",
                            "&:hover": { background: "#007BFFc3" },
                        }}
                        onClick={() => setActiveTab("chat")}
                        startIcon={<Reply sx={{ transform: "rotateY(180deg)" }} />}
                    >
                        Start Chat
                    </Button>
                </Box>
            </Box>
            <Box sx={{ width: "100%", mt: "2vh", height: "90%" }}>
                <Tabs value={value} sx={{ borderBottom: "1px solid #F3F3F4" }}>
                    <Tab
                        onClick={() => setValue("all")}
                        value={"all"}
                        label="All"
                        sx={{ textTransform: "none", mr: 2 }}
                    />
                    <Tab
                        onClick={() => setValue(".mp4")}
                        value={".mp4"}
                        label="Videos"
                        sx={{ textTransform: "none", mr: 2 }}
                    />
                    <Tab
                        onClick={() => setValue("pdf")}
                        value={"pdf"}
                        label="Pdf"
                        sx={{ textTransform: "none", mr: 2 }}
                    />
                    <Tab
                        onClick={() => setValue("excel")}
                        value={"excel"}
                        label="Excel"
                        sx={{ textTransform: "none", mr: 2 }}
                    />
                    <Tab
                        onClick={() => setValue("word")}
                        value={"word"}
                        label="Word"
                        sx={{ textTransform: "none", mr: 2 }}
                    />
                    <Tab
                        onClick={() => setValue("pptx")}
                        value={"pptx"}
                        label="Ppt"
                        sx={{ textTransform: "none", mr: 2 }}
                    />
                </Tabs>
                <TabsAndFileRenderer value={value} searchInput={searchInput} />
            </Box>
        </Box>
    );
};

export default FilesContent;
